module.exports = __webpack_public_path__ + "./sophia_6e4528688b1a86fc73814d460a092e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/sophia.png
// module id = 472
// module chunks = 0